import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AnaStory } from './components/AnaStory';
import { WhyItFails } from './components/WhyItFails';
import { Pillars } from './components/Pillars';
import { Method } from './components/Method';
import { ThirtyDayPlan } from './components/ThirtyDayPlan';
import { TrustBand } from './components/TrustBand';
import { Conclusion } from './components/Conclusion';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TrustBand data-id="element-4" />
        <AnaStory data-id="element-5" />
        <WhyItFails data-id="element-6" />
        <Pillars data-id="element-7" />
        <Method data-id="element-8" />
        <ThirtyDayPlan data-id="element-9" />
        <Conclusion data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}